module.exports = __webpack_public_path__ + "img/12.44987be1.png";